<script>
import { mapGetters } from 'vuex';
import request from '@/utils/request';
import PaginatedList from '@/views/components/PaginatedList';
import ComplaintsHeader from './components/ComplaintsHeader';
import Complaint from './components/Complaint';

export default {
  components: {
    ComplaintsHeader,
    Complaint,
  },
  extends: PaginatedList,
  data() {
    return {
      taxes: [],
      availabilities: [],
    };
  },
  computed: {
    ...mapGetters({
      items: 'complaints/list/getData',
      paginationParams: 'complaints/list/getPaginationParams',
      isLoadingComplaints: 'complaints/list/getIsLoading',
      isLoaded: 'complaints/list/getIsLoaded',
    }),
  },
  methods: {
    async closeModal(response) {
      try {
        this.isOpen = !this.isOpen;

        if (response) {
          await request.delete(`/complaints/${this.selectedItem.uuid}`);

          await this.navigate({
            timestamp: new Date().getTime(),
          });

          this.$notify({
            type: 'success',
            title: 'Επιτυχία',
            text: 'Το παράπονο διαγράφτηκε επιτυχώς!!',
          });
        }
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'To αίτημα απέτυχε',
        });
      }
    },
  },
};
</script>
